import 'md5';
export default class QuestionsService {
    constructor(questionsFile) {
        this.questionsFile = questionsFile;
    }
    async getQuestions() {
        const response = await fetch(this.questionsFile);
        const questions = await response.json();
        return questions;
    }
}
